import { PropsWithChildren, useContext, useEffect } from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';

interface MicroWrapperProps {
  showHead: boolean;
  showNav: boolean;
  headerExtraProps: any;
}

function MicroWrapper(props: PropsWithChildren<MicroWrapperProps>) {
  const { showHead = true, showNav = true, headerExtraProps } = props;
  const values = useContext(ContextProviderMenus);
  const { setShowHeader, setShowNav, setHeaderExtraProps } = values;
  useEffect(() => {
    setShowHeader(showHead);
    setShowNav(showNav);
    headerExtraProps && setHeaderExtraProps(headerExtraProps);
    return () => {
      setShowHeader(true);
      setShowNav(true);
      setHeaderExtraProps({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return props.children;
}

export default MicroWrapper;
